import axios from 'axios';

axios.defaults.headers['X-CSRF-TOKEN'] = document.querySelector('meta[name=csrf-token]').getAttribute('content');

export class Http {
  constructor() {
    this.axios = axios;
  }

  /**
   * Get
   * @param url
   * @param params
   * @returns {AxiosPromise<any>}
   */
  get(url, params = {}) {
    return axios.get(url, { params });
  }

  /**
   * Post
   * @param url
   * @param params
   * @returns {AxiosPromise<any>}
   */
  post(url, params = {}) {
    return axios.post(url, params);
  }
}

export default new Http();
